import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../helpers/appHelper';
import * as appConstants from '../constants/appConstants';
import * as localStorage from '../localStorage/localStorage';

class AppFooter extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            locale: {},
            assets: {
                logo: {
                    src: "",
                }
            },
            setLocale: false,
        };
        this.getLocale = this.getLocale.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
    }

    componentDidMount() {
        this.getLocale();
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                setLocale: true
            });
        }
    }

    componentDidUpdate(){
        if(this.state.setLocale){
            this.getLocale();
        }

    }

    getLocale() {
        let locale = appHelper.getLocalData(this.props.contentData.experience);
        this.setState({locale: Object.assign({}, locale), setLocale: false});
    }

    getAssets() {

        let logoAsset = appHelper.getFooterLogoAsset(this.props.contentData.experience.footer_logo);
        if(appHelper.isDefined(logoAsset)) {
            this.setState({
                assets: Object.assign({}, this.state.assets, {
                    logo: logoAsset
                })
            });
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if(appHelper.isDefined(image) && image.length > 0) {
                return require(`../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        return (
            <div className="footer">
                <div className="inline-content">
                    <div className="content-item footer-text">
                        {
                            appHelper.isDefined(this.state.locale.footer_text)
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.footer_text}}/>
                                :
                                null
                        }

                    </div>
                    <div className="content-item text-right">
                        {
                            this.state.assets.logo.src.length > 0
                                ?
                                <div className="footer-logo-container">
                                    {
                                        appHelper.isDefined(this.state.assets.logo) && this.state.assets.logo.src.length > 0
                                        ?
                                            <img src={this.getImagePath(this.state.assets.logo.src)} alt=""/>
                                        :
                                            null
                                    }

                                </div>
                                :
                                null
                        }

                    </div>
                </div>
            </div>
        );
    }
}

AppFooter.propTypes = {
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string,
};

AppFooter.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        contentData: state.contentData,
        lang:lang
    };
}

export default connect(mapStateToProps)(AppFooter);



/** WEBPACK FOOTER **
 ** ./src/components/AppFooter.js
 **/